import { DefaultPageHeader } from 'layouts';
import type { OrganizationDetail } from 'models';
import { Card } from 'ui';
import { useGetOrganizationEntityBreadcrumb } from '../hooks';
import { OrganizationsProgramsList } from './organizations-programs-list';

type P = {
  getPathToProgramDetail: (id: string) => string;
  organization: OrganizationDetail;
};

const OrganizationsPrograms = ({ getPathToProgramDetail, organization }: P) => {
  const breadcrumbRoutes = useGetOrganizationEntityBreadcrumb({ entityType: 'programs', organization });

  return (
    <>
      <DefaultPageHeader routes={breadcrumbRoutes} title="Programs" />
      <Card>
        <OrganizationsProgramsList getPathToProgramDetail={getPathToProgramDetail} organizationId={organization.id} />
      </Card>
    </>
  );
};

export default OrganizationsPrograms;
